import React, { useEffect, useState } from 'react';
import { Container, InputGroup } from 'react-bootstrap';
import {
    emailValidation,
    groupSort,
    passwordMatch,
    passwordValidation,
    requiredFieldValidation
} from '../../utils/validation'
import Grid from '@mui/material/Grid';
import { PrimaryButton, Loader, InputField, Select, SearchAutocomplete, PhoneInputField } from '../../elements';

const rolesOptions = [
    { value: 'admin', label: 'Admin' },
    { value: 'teacher', label: 'Teacher' },
    { value: 'student', label: 'Student' },
]

const UpdateUserPage = (props) => {

    let { updateUser, isUserUpdated, userById, fetchUser, userId, groups, fetchGroups, isLoading } = props

    const [firstName, setFirstName] = useState({ value: '', error: '' })
    const [lastName, setLastName] = useState({ value: '', error: '' })
    const [email, setEmail] = useState({ value: '', error: '' })
    const [phone, setPhone] = useState({ value: '', error: '' })
    const [password, setPassword] = useState({ value: '', error: '' })
    const [confirmPassword, setConfirmPassword] = useState({ value: '', error: '' })
    const [passwordCheck, setPasswordCheck] = useState({ error: '' })
    const [role, setRole] = useState({ value: '', error: '' })
    const [group, setGroup] = useState({ value: [], error: '' })
    const [codewars, setCodewars] = useState({ value: '', error: '' })
    const [groupsList, setGroupsList] = useState([])

    useEffect(() => {
        fetchUser(userId)
        fetchGroups(userId)
        // eslint-disable-next-line
    }, [userId])

    useEffect(() => {
        if (Object.keys(userById).length > 0) {
            setEmail({ value: userById.email || '' })
            setFirstName({ value: userById.firstName || '' })
            setLastName({ value: userById.lastName || '' })
            setPhone({ value: userById.phone || '' })
            let optional = { ...userById.optional }
            setRole({ value: optional && (optional.role || '') })
            setGroup({ value: optional && (optional?.groups?.filter(el => Boolean(el)) || []) })
            setCodewars({ value: optional && (optional.username || '') })
        } else {
            setEmail({ value: '', error: '' })
            setFirstName({ value: '', error: '' })
            setLastName({ value: '', error: '' })
            setPhone({ value: '', error: '' })
            setPassword({ value: '', error: '' })
            setConfirmPassword({ value: '', error: '' })
            setRole({ value: '', error: '' })
            setGroup({ value: [], error: '' })
        }
    }, [userById])

    useEffect(() => {
        if (groups?.length > 0) {
            setGroupsList(groups)
        } else {
            setGroupsList([])
        }

    }, [groups])

    const handleFirstName = (value) => {
        if (requiredFieldValidation(value, 'First Name')) {
            setFirstName({ value: value, error: requiredFieldValidation(value, 'First Name') })
        } else {
            setFirstName({ value: value })
        }
    }

    const handleLastName = (value) => {
        if (requiredFieldValidation(value, 'Last Name')) {
            setLastName({ value: value, error: requiredFieldValidation(value, 'Last Name') })

        } else {
            setLastName({ value: value })
        }
    }

    const handlePhone = (value) => {
        if (requiredFieldValidation(value, 'Phone number')) {
            setPhone({ value: value, error: requiredFieldValidation(value, 'Phone number') })
        } else {
            setPhone({ value: value })
        }
    }

    const handleEmail = (value) => {
        if (emailValidation(value)) {
            setEmail({ value: value, error: emailValidation(value) })

        } else {
            setEmail({ value: value })
        }
    }

    const handlePassword = (value) => {
        if (passwordValidation(value)) {
            setPassword({ value: value, error: passwordValidation(value) })
        } else {
            setPassword({ value: value })
        }

    }

    const handleConfirmPassword = (value) => {
        if (passwordValidation(value)) {
            setConfirmPassword({ value: value, error: passwordValidation(value) })
        } else {
            setConfirmPassword({ value: value })
        }
    }

    useEffect(() => {
        if (passwordMatch(password.value, confirmPassword.value)) {
            setPasswordCheck({ error: passwordMatch(password.value, confirmPassword.value) })
        } else {
            setPasswordCheck({ error: '' })
        }
    }, [password.value, confirmPassword.value])

    const checkGroup = (j) => group && group.value && group.value.some((el) => el === j)

    const onSelectGroupHandler = (g) => {
        if (checkGroup(g)) {
            setGroup({ value: group.value.filter(el => Boolean(el) && el !== g) })
        } else {
            setGroup({ value: [...group.value, g].filter(el => Boolean(el)) })
        }
    }
    const submitUser = () => {
        let tempUser = { id: userId }
        let tempOptional = {}
        if (firstName.value && !(firstName.error)) {
            tempUser.firstName = firstName.value
        } else return handleFirstName(firstName.value)
        if (lastName.value && !(lastName.error)) {
            tempUser.lastName = lastName.value
        } else return handleLastName(lastName.value)
        if (email.value && !(email.error)) {
            tempUser.email = email.value
        } else return handleEmail(email.value)
        if (password.value && !(password.error) && !(passwordCheck.error)) {
            tempUser.password = password.value
        }
        if (role.value && !(role.error)) {
            tempOptional.role = role.value
        }
        if (phone.value && phone.value !== '(' && !(phone.error)) {
            tempUser.phone = phone.value
        }
        if (group.value?.filter(el => Boolean(el))?.length && !(group.error)) {
            tempOptional.groups = group.value.filter(el => Boolean(el))
        }
        if (codewars.value && !(codewars.error)) {
            tempOptional.username = codewars.value
        }

        tempUser.optional = tempOptional
        updateUser(tempUser)
    }

    return (<div>
        {isLoading && <Loader />}
        <div className="text-center">
            <Container maxWidth='xs' style={{ padding: '24px' }}>
                <h1 className="text-center">Update User</h1>
                <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                    onChange={
                        (e) => handleFirstName(e.target.value)
                    }
                    label='First Name'
                    value={firstName.value}
                    error={firstName.error}
                />

                <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                    onChange={
                        (e) => handleLastName(e.target.value)
                    }
                    label='Last Name'
                    value={lastName.value}
                    error={lastName.error}
                    required={true}
                />
                <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                    onChange={
                        (e) => handleEmail(e.target.value)
                    }
                    label='E-mail'
                    value={email.value}
                    error={email.error}
                />
                <PhoneInputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                    label='Phone number'
                    value={phone.value}
                    error={phone.error}
                    onChange={e => handlePhone(e.target.value)}
                />
                {(props.currentUser.id === props.userId) && <>
                    <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                        onChange={
                            (e) => handlePassword(e.target.value)
                        }
                        label='Password'
                        value={password.value}
                        error={password.error}
                    />
                    <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                        onChange={
                            (e) => handleConfirmPassword(e.target.value)
                        }
                        value={confirmPassword.value}
                        error={confirmPassword.error}
                        label='Confirm Password'
                    />
                    <div style={{ color: 'red' }} className=" ml-3 ">{passwordCheck.error}</div>
                </>
                }
                <InputGroup className="mb-3">
                    {
                        (props.currentUser && props.currentUser.optional && props.currentUser.optional.role === 'admin' && (props.currentUser.id === props.userId)) ?
                            <InputField
                                value={role.value}
                                disabled={true}
                                label='Role'
                            />
                            : (props.currentUser && props.currentUser.optional && props.currentUser.optional.role === 'admin') ?
                                <Select
                                    label='Role'
                                    onChange={(e) => setRole({ value: e.target.value })}
                                    value={role.value}
                                    options={rolesOptions}
                                />
                                :
                                <InputField
                                    value={role.value}
                                    disabled={true}
                                    label='Role'
                                />
                    }
                </InputGroup>
                {!(role.value === 'admin') &&
                    <InputField aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                        onChange={(e) => setCodewars({ value: e.target.value })}
                        value={codewars.value}
                        label='CodeWars username'
                    />
                }

                <div className="justify-content-md-start mt-3">
                    {
                        role.value === 'admin' ?
                            null
                            : (props.currentUser && props.currentUser.optional && props.currentUser.optional.role === 'admin') ?
                                <>
                                    <Grid container spacing={4} columns={{ xs: 4, sm: 8, md: 12 }}>
                                        <Grid item xs={2} sm={4} md={6}>
                                            <SearchAutocomplete
                                                optionList={groupSort(groupsList)}
                                                selectedOptions={group.value}
                                                onSelectOption={onSelectGroupHandler}
                                            />
                                        </Grid>
                                    </Grid>

                                    {!!group?.value?.length ? <Grid container spacing={4} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ mt: 0 }}>
                                        {groupSort(group.value).map((el, index) => (
                                            <Grid item xs={1} sm={2} md={3} key={index}>
                                                <div style={{
                                                    height: "40px",
                                                    backgroundColor: "rgba(230, 145, 56, .7)",
                                                    borderRadius: "2px",
                                                    lineHeight: "40px"
                                                }}>{el}</div>
                                            </Grid>
                                        ))}
                                    </Grid> : null}
                                </>
                                :
                                <div>
                                    <div style={{textAlign: 'start', color: 'var(--placeholder-text)'}}>Groups</div>
                                    <Grid container spacing={4} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ mt: 0 }}>
                                        {groupSort(group.value).map((el, index) => (
                                            <Grid item xs={1} sm={2} md={3} key={index}>
                                                <div style={{
                                                    height: "40px",
                                                    backgroundColor: "rgba(230, 145, 56, .7)",
                                                    borderRadius: "2px",
                                                    lineHeight: "40px"
                                                }}>{el}</div>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </div>
                    }
                </div>

                <PrimaryButton
                    style={{ marginTop: '40px' }}
                    onClick={() => submitUser()}
                    fullWidth={true}
                >
                    Update
                </PrimaryButton>

                {isUserUpdated ?
                    <div style={{ color: 'green' }} className=" ml-3 ">User updated</div>
                    :
                    <div style={{ color: 'red' }} className=" ml-3 ">{props.error}</div>
                }
            </Container>
        </div>
    </div>
    )
}

export default UpdateUserPage